import {Constants} from "./constants";

export type Form = {
    id: string;
    name: string;
};

export type Project = {
    id: string;
    name: string;
    forms: Form[];
};

export function getProjectByFormId(formId: string): Project | undefined {
    return mockProjects.find(project =>
        project.forms.some(form => form.id === formId)
    );
}

export const APPIMAGES = Constants.appImages

export const mockProjects: Project[] = [
    {
        id: 'project1',
        name: 'Marketing Website',
        forms: [
            {id: 'form1', name: 'Contact Form'},
            {id: 'form2', name: 'Newsletter Signup'}
        ]
    },
    {
        id: 'project2',
        name: 'SaaS Dashboard',
        forms: [
            {id: 'form3', name: 'Feedback Form'}
        ]
    }
];

export const mockSurveys = [
    {
        form_id: "form1",
        data: {
            email: "a.b@c.d",
            company: "Azienda",
            lang: "es",
            questions: [
                {
                    question_id: 1,
                    text: "¿Tu organización dispone de una política de ciberseguridad documentada y actualizada?",
                    response: "Sí, revisada trimestralmente"
                },
                {
                    question_id: 2,
                    text: "¿Con qué frecuencia se realizan copias de seguridad de los datos críticos?",
                    response: "Diariamente"
                },
                {
                    question_id: 3,
                    text: "¿Se ha implementado la autenticación multifactor (MFA) en los sistemas de la empresa?",
                    response: "En todos los accesos externos"
                },
                {
                    question_id: 4,
                    text: "¿Con qué frecuencia se realizan evaluaciones del riesgo informático?",
                    response: "Cada 6 meses"
                },
                {
                    question_id: 5,
                    text: "¿Los empleados reciben formación sobre concienciación en ciberseguridad?",
                    response: "Anualmente"
                },
                {
                    question_id: 6,
                    text: "¿Existe un plan de respuesta ante incidentes de seguridad informática? ¿Ha sido probado?",
                    response: "Sí, probado en el último trimestre"
                },
                {
                    question_id: 7,
                    text: "¿Los sistemas operativos y el software se actualizan regularmente con parches de seguridad?",
                    response: "Automáticamente cada semana"
                },
                {
                    question_id: 8,
                    text: "¿Cómo se gestiona el acceso a los datos sensibles?",
                    response: "Con roles definidos y revisiones mensuales"
                },
                {
                    question_id: 9,
                    text: "¿Todos los dispositivos de la empresa están protegidos con antivirus o software de protección de endpoints?",
                    response: "Sí, centralizado desde consola de seguridad"
                },
                {
                    question_id: 10,
                    text: "¿Cómo se monitorean y detectan las amenazas informáticas?",
                    response: "A través de un SIEM y alertas automáticas"
                }
            ]
        },
        metadata: {
            captcha_score: 0.9,
            created_at: "2025-07-11T12:09:19Z"
        }
    },
];
